import React from 'react';
import Routes from './components/Auth/Routes/Routes';

const App = () => {
  return (
    <>
      <Routes />
    </>
  );
};

export default App;
